<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-duplicate`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40.625 5.958a1 1 0 011.168-.633l.112.033 2.819 1.02a1 1 0 01.643 1.122l-.027.11-9.01 29.531-4.701-1.7 8.996-29.483zM35.748 38.99L31 37.313v5.184a.6.6 0 001.036.412l3.712-3.919zM24 39a1 1 0 00-1-1H4a1 1 0 00-1 1v2a1 1 0 001 1h19a1 1 0 001-1v-2zm0-10a1 1 0 00-1-1H4a1 1 0 00-1 1v2a1 1 0 001 1h19a1 1 0 001-1v-2zm5-23a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h24zM7 10h20v8H7v-8z"/></svg>
</template>
<script>

export default {
  name: 'IconDuplicate',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
